<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Tab',
    },
  },
  data() {
    return {
      isActive: true,
    }
  },
}
</script>

<template lang="html">
  <div v-show="isActive" class="tab">
    <slot></slot>
  </div>
</template>
